import { render } from "./AuthorizationPopUp.vue?vue&type=template&id=cfeb01e4&scoped=true"
import script from "./AuthorizationPopUp.vue?vue&type=script&lang=js"
export * from "./AuthorizationPopUp.vue?vue&type=script&lang=js"

import "./AuthorizationPopUp.vue?vue&type=style&index=0&id=cfeb01e4&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfeb01e4"]])

export default __exports__